import { BottomTabBarOptions } from "@react-navigation/bottom-tabs";

const tabBarOptions: BottomTabBarOptions = {};

export default tabBarOptions;
